import Admin from '#admin/modules/admin';

const admin = new Admin();

admin.init();
